<div class="flex flex-col h-full">
  <div class="flex justify-between mb-4">
    <div class="flex w-1/5">
      <elcia-search [control]="searchControl"/>
    </div>
    <div class="flex gap-2">
      <div>
        <elcia-button (onClick)="toggleFilterDisplayed()" [icon]="'filter'" [label]="'app.filters' | translate" [severity]="isFilterDisplayed() ? 'primary' : 'secondary'"
                      ]/>
      </div>
      <div>
        <elcia-button (onClick)="navToForm()" [icon]="'plus'" [label]="'action.add-contact' | translate"/>
      </div>
    </div>
  </div>

  @if (isFilterDisplayed()) {
    <elcia-filter-container>
      <elcia-customer-state-dropdown [control]="statesControl"/>
    </elcia-filter-container>
  }

  <div class="h-full">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-contact-grid (contactSelected)="onContactSelected($event)" (onDelete)="onContactDelete($event)"
                          [contacts]="contacts()" [isLoading]="isLoading()"/>
    }
  </div>
</div>
